import ProfileCard from '../../profileCard/ProfileCard';
import { HomePersonGridLayout } from '../homePersonGrid.styles';

const HomePersonGridList = ({ persons, onSelectProfile, onReload }) => (
	<HomePersonGridLayout>
		{persons.map((profile) => (
			<ProfileCard
				key={profile._id || profile.id}
				profile={profile}
				onClick={onSelectProfile}
				onReload={onReload}
			/>
		))}
	</HomePersonGridLayout>
);

export default HomePersonGridList;
